export const noopSanitizeJSON = (json: any) => json;
